import {EncryptionKeys} from "../model/encryption-keys.model";

export class CreateEncryptionKeyDto {

  account_id: string;
  key: string;
  salt: string;
  publicKey: string;
  iv: string;
  recoveryKey: EncryptionKeys;
}
